import { render, staticRenderFns } from "./BuyClover.vue?vue&type=template&id=0ab3d7a0&lang=pug&"
import script from "./BuyClover.vue?vue&type=script&lang=js&"
export * from "./BuyClover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports